module.exports = __webpack_public_path__ + "img/credit_card_icon.aa0deed8.svg";